import type { UserProfile } from '@factoryfixinc/ats-interfaces';
import { InternalError } from './internal.error';

export class UserAlreadyAppliedError extends InternalError {
  constructor(userProfile: Pick<UserProfile, 'id' | 'nameFirst' | 'nameLast'>, jobId: number) {
    super('User already applied', { data: { userProfile, jobId } });
  }
}
